import { DefaultApolloClient } from '@vue/apollo-composable';
import { provide } from 'vue';

import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: process.env.VUE_APP_GRAPHQL_API_URL,
});

const authLink = setContext((_, { headers }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.jwt;
  // const token = localStorage.getItem('ACCESS_TOKEN');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export function useApollo() {
  provide(DefaultApolloClient, apolloClient);
}
